import { useQueries } from '@tanstack/react-query';
import type { AdminClientModule, ModuleSection } from '@wit-support/ui-domain';

/**
 * Подразделы с `availability` (выключаемые на сервере, например журнал)
 * скрываются, только когда проверка ответила `false`; пока она идёт или упала — подраздел виден (без мигания и перескока подсветки). Число запросов зависит
 * от списка модулей — `useQueries` это допускает.
 */
export function useAvailableSections(
  modules: readonly AdminClientModule[],
): readonly AdminClientModule[] {
  const checks = modules.flatMap((m) =>
    (m.sections ?? []).flatMap((s) => (s.availability ? [{ m, s, a: s.availability }] : [])),
  );
  const results = useQueries({
    queries: checks.map(({ a }) => ({
      queryKey: a.queryKey,
      queryFn: a.queryFn,
      staleTime: a.staleTime ?? 5 * 60_000,
      retry: false,
    })),
  });
  if (checks.length === 0) return modules;
  const hidden = new Set<ModuleSection>();
  checks.forEach(({ s }, i) => {
    // прячет только явное «нет»: ожидание и ошибка проверки пункт не убирают
    if (results[i]?.data === false) hidden.add(s);
  });
  if (hidden.size === 0) return modules;
  return modules.map((m) =>
    (m.sections ?? []).some((s) => hidden.has(s))
      ? { ...m, sections: (m.sections ?? []).filter((s) => !hidden.has(s)) }
      : m,
  );
}
